import React, { useRef, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { formatCurrency, downloadOutputData, downloadExcel } from "../utils";
import { Payments } from "../components/payments/Payments";
import {
  BankPaymentStatementItem,
  PaymentRegisterItem,
  PaymentsOutput,
} from "../components/payments/types";
import { matchDisbursements } from "../components";
import { useHistory } from "react-router-dom";
import { readExcelFile, addUniqueId, getDataCopy, getTable } from "../App";

const ChequeAndCrediCardNumColumnName = "Cheque No/ Credit Card No";
const DebitAmountColumnName = "Debit Amount";
const CreditAmountColumnName = "Credit Amount";
const SwipingMachineId = "91984379";
const BankStatementDepositsColumnName = "Deposits";
export const BankStatementRemarksColumnName = "Remarks";
const BankStatementDateColumnName = "Date";
const CollectionReportDateColumnName = "Collection Date";

function NIAPage() {
  const history = useHistory();
  const [bankStatementsMasterData, setBankStatementsMasterData] = useState<
    unknown[] | undefined
  >();
  const [
    previousMonthBankStatementsMasterData,
    setPreviousMonthBankStatementsMasterData,
  ] = useState<unknown[] | undefined>();
  const [collectionReportsMasterData, setCollectionReportsMasterData] =
    useState<unknown[] | undefined>();
  const [
    previousMonthCollectionReportsMasterData,
    setPreviousMonthCollectionReportsMasterData,
  ] = useState<unknown[] | undefined>();
  const [outputData, setOutputData] = useState<any>();
  const [paymentBankStatementData, setPaymentsBankStatementData] =
    useState<BankPaymentStatementItem[]>();
  const [paymentRegisterData, setPaymentRegisterData] =
    useState<PaymentRegisterItem[]>();
  const outsatndingChequeTableContainerRef = useRef<HTMLDivElement>(null);
  const outsatndingBankCreditAdviceTableContainerRef =
    useRef<HTMLDivElement>(null);
  const matchingCreditAdviceTableContainerRef = useRef<HTMLDivElement>(null);
  const matchingBankStatementsTableContainerRef = useRef<HTMLDivElement>(null);
  const outstandingBankStatementsTableContainerRef =
    useRef<HTMLDivElement>(null);
  const byCashTableContainerRef = useRef<HTMLDivElement>(null);

  async function handleBankStatementFileSelection(
    fileChangeEvent: React.ChangeEvent<HTMLInputElement>
  ) {
    const bankStatements = (await readExcelFile(fileChangeEvent)) || [];
    const bankStatementsWithUniqueId = addUniqueId(bankStatements);
    const bankStatementsMasterDataWithUniqueId = getDataCopy(
      bankStatementsWithUniqueId
    );
    setBankStatementsMasterData(bankStatementsMasterDataWithUniqueId);
  }

  async function handleCollectionReportFileSelection(
    fileChangeEvent: React.ChangeEvent<HTMLInputElement>
  ) {
    const collectionReports = (await readExcelFile(fileChangeEvent)) || [];
    const collectionReportsWithUniqueId = addUniqueId(collectionReports);
    const collectionReportsMasterDataWithUniqueId = getDataCopy(
      collectionReportsWithUniqueId
    );
    setCollectionReportsMasterData(collectionReportsMasterDataWithUniqueId);
  }

  async function handlePreviousMonthCollectionReportFileSelection(
    fileChangeEvent: React.ChangeEvent<HTMLInputElement>
  ) {
    const previousMonthCollectionReports =
      (await readExcelFile(fileChangeEvent)) || [];
    const collectionReportsWithUniqueId = addUniqueId(
      previousMonthCollectionReports
    );
    const collectionReportsMasterDataWithUniqueId = getDataCopy(
      collectionReportsWithUniqueId
    );
    setPreviousMonthCollectionReportsMasterData(
      collectionReportsMasterDataWithUniqueId
    );
  }

  async function handlePreviousMonthBankStatementFileSelection(
    fileChangeEvent: React.ChangeEvent<HTMLInputElement>
  ) {
    const previousMonthBankStatement =
      (await readExcelFile(fileChangeEvent)) || [];
    const previousMonthBankStatementWithUniqueId = addUniqueId(
      previousMonthBankStatement
    );
    const bankStatementsMasterDataWithUniqueId = getDataCopy(
      previousMonthBankStatementWithUniqueId
    );
    setPreviousMonthCollectionReportsMasterData(
      bankStatementsMasterDataWithUniqueId
    );
  }

  function matchChequeAndBCA(
    bankStatements1: unknown[],
    collectionReports1: unknown[]
  ) {
    const {
      bankStatements: bankStatementsMasterDataCopy,
      collectionReports: collectionReportsMasterDataCopy,
      previousMonthollectionReports:
        previousMonthollectionReportsMasterDataCopy,
    } = resetBankStatementsAndCollectionData();
    const {
      bankStatements: bankStatementsPostCashTransactions,
      byCashTransactions,
      totalByCashAmount,
    } = findByCashTransactionRows(bankStatementsMasterDataCopy);
    const outstandingChequeDetails = findOutstandingCheques(
      bankStatementsPostCashTransactions,
      collectionReportsMasterDataCopy
    );
    const {
      bankStatements: bankStatementsPostPreviousMonthChequeCalc,
      outstandingCheques: previousMonthOutstandingCheques,
      matchedChequeInBankStatements: previousMonthClearedCheques,
      allChequeEntriesInCollectionRegister: previousMonthAllCheques,
    } = findOutstandingCheques(
      outstandingChequeDetails.bankStatements,
      previousMonthollectionReportsMasterDataCopy
    );
    const bcaDetails = calculateTotalBankCreditAdviceAmount(
      bankStatementsPostPreviousMonthChequeCalc,
      outstandingChequeDetails.collectionReports
    );

    const allMatchedBankStatements = getAllMatchedBankStatements(
      bcaDetails.bankStatements
    );
    const paymentsOutput: PaymentsOutput | undefined =
      paymentRegisterData && paymentBankStatementData
        ? matchDisbursements(paymentRegisterData, paymentBankStatementData)
        : undefined;
    setOutputData({
      ...outstandingChequeDetails,
      ...bcaDetails,
      allMatchedBankStatements,
      byCashTransactions,
      totalByCashAmount,
      previousMonthOutstandingCheques,
      previousMonthClearedCheques,
      previousMonthAllCheques,
      bankStatements: bcaDetails.bankStatements,
      collectionReports: bcaDetails.collectionReports,
      paymentsOutput,
    });
  }

  function resetBankStatementsAndCollectionData() {
    const bankStatements = getDataCopy(bankStatementsMasterData || []);
    const collectionReports = getDataCopy(collectionReportsMasterData || []);
    const previousMonthollectionReports = getDataCopy(
      previousMonthCollectionReportsMasterData || []
    );
    return {
      bankStatements,
      collectionReports,
      previousMonthollectionReports,
    };
  }

  function calculateTotalBankCreditAdviceAmount(
    bankStatements: any[],
    collectionReports: any[]
  ) {
    const bankStatementsEntryCopy = bankStatements.map((statement) => {
      return { ...statement };
    });
    const collectionReportsCopy = getDataCopy(collectionReports);
    const allBankCreditAdviceCollectionReportEntriesExludingSwipeEntries =
      getAllBankCreditAdviceEntryExcludingSwipeEntryFromCollectionReposrts(
        collectionReportsCopy
      );
    const outstandingBCA: any[] = [];
    const bankCreditAdviceFoundInBankStatements: any[] = [];
    allBankCreditAdviceCollectionReportEntriesExludingSwipeEntries.forEach(
      (collectionReportBCA) => {
        const collectionDebitAmount = Math.round(
          Number(collectionReportBCA[DebitAmountColumnName])
        );
        const bankStatementCorrespondingEntry = bankStatementsEntryCopy.find(
          (bankStatementBCA) => {
            const alreadyMatched = !!bankStatementBCA.alreadyMatched;
            const bankDepositRemarks =
              bankStatementBCA[BankStatementRemarksColumnName];
            const bankDepositAmount = Math.round(
              Number(bankStatementBCA[BankStatementDepositsColumnName])
            );
            const isNeftTransactions =
              bankDepositRemarks.indexOf("NEFT:") > -1 ||
              bankDepositRemarks.indexOf("NEW INDIA ASSURANCE CO LTD") > -1 ||
              (bankDepositRemarks.indexOf("BY CASH") === -1 &&
                bankDepositRemarks.indexOf("BY INST") === -1);
            const isMatch =
              isNeftTransactions &&
              bankDepositAmount === collectionDebitAmount &&
              !alreadyMatched;
            if (isMatch) {
              bankStatementBCA.alreadyMatched = true;
              bankStatementBCA.type = "Bank Credit Advice";
              bankStatementBCA.matchingCREntry = {
                ...collectionReportBCA,
                matchingBankStatement: undefined,
              };
            }
            return isMatch;
          }
        );
        if (!bankStatementCorrespondingEntry) {
          outstandingBCA.push(collectionReportBCA);
        } else {
          collectionReportBCA.matchingBankStatement = {
            ...bankStatementCorrespondingEntry,
            matchingCREntry: undefined,
          };
          bankCreditAdviceFoundInBankStatements.push(collectionReportBCA);
        }
      }
    );
    const outstandingBCAAmount: number = findSum(
      outstandingBCA,
      DebitAmountColumnName
    );
    const allBankCreditAdviceCollectionReportEntriesExludingSwipeEntriesAmount =
      findSum(
        allBankCreditAdviceCollectionReportEntriesExludingSwipeEntries,
        DebitAmountColumnName
      );
    return {
      allBankCreditAdviceCollectionReportEntriesExludingSwipeEntries,
      outstandingBCA,
      outstandingBCAAmount,
      allBankCreditAdviceCollectionReportEntriesExludingSwipeEntriesAmount,
      bankCreditAdviceFoundInBankStatements,
      bankStatements: bankStatementsEntryCopy,
      collectionReports: collectionReportsCopy,
    };
  }

  function getAllBankCreditAdviceEntryExcludingSwipeEntryFromCollectionReposrts(
    collectionReports: any[]
  ) {
    const allBankCreditAdviceCollectionReportEntries =
      findEntriesByPaymentCategory(collectionReports, "Bank Credit Advice");
    const allBankCreditAdviceCollectionReportEntriesExludingSwipeEntries =
      allBankCreditAdviceCollectionReportEntries.filter(
        (collectionReportEntry) => {
          const chequeId =
            collectionReportEntry[ChequeAndCrediCardNumColumnName];
          return chequeId !== SwipingMachineId;
        }
      );
    return allBankCreditAdviceCollectionReportEntriesExludingSwipeEntries;
  }

  function findOutstandingCheques(
    bankStatements: any[],
    collectionReports: any[]
  ) {
    const bankStatementsCopy = getDataCopy(bankStatements);
    const collectionReportsCopy = getDataCopy(collectionReports);
    const allChequeEntriesInCollectionRegister = getAllChequesAndDrafts(
      collectionReportsCopy
    );
    const chequeDuplicateEntriesInBankStatements: any[] = [];
    const matchedChequeInBankStatements: any[] = [];
    const outstandingCheques: any[] = [];
    const rejectedCheques: any[] = [];
    allChequeEntriesInCollectionRegister.forEach((chequeEntry) => {
      const chequeNumber = Number(chequeEntry[ChequeAndCrediCardNumColumnName]);
      const depositMatchRegex = new RegExp(`(BY INST ${chequeNumber} :)`);
      const rejectMatchRegex = new RegExp(`(REJECT:${chequeNumber}:)`);
      const correspondingChequeEnetriesInBankStatements =
        bankStatementsCopy.filter((bankEntry) => {
          const remarks = bankEntry["Remarks"];
          return (
            remarks.match(depositMatchRegex) || remarks.match(rejectMatchRegex)
          );
        });
      if (correspondingChequeEnetriesInBankStatements.length === 0) {
        outstandingCheques.push(chequeEntry);
      } else if (correspondingChequeEnetriesInBankStatements.length > 1) {
        const depositEntries =
          correspondingChequeEnetriesInBankStatements.filter((bankEntry) => {
            const remarks = bankEntry["Remarks"];
            return remarks.match(depositMatchRegex);
          });
        const rejectedEntries =
          correspondingChequeEnetriesInBankStatements.filter((bankEntry) => {
            const remarks = bankEntry["Remarks"];
            return remarks.match(rejectMatchRegex);
          });
        if (rejectedEntries.length === depositEntries.length - 1) {
          chequeEntry.matchingBankStatement = {
            ...correspondingChequeEnetriesInBankStatements[0],
            matchingCREntry: undefined,
          };
          correspondingChequeEnetriesInBankStatements[0].alreadyMatched = true;
          correspondingChequeEnetriesInBankStatements[0].type = "CHECK/DRAFT";
          correspondingChequeEnetriesInBankStatements[0].matchingCREntry = {
            ...chequeEntry,
            matchingBankStatement: undefined,
          };
          matchedChequeInBankStatements.push(chequeEntry);
        } else if (rejectedEntries.length === depositEntries.length) {
          outstandingCheques.push({ ...chequeEntry });
          rejectedCheques.push({
            [chequeNumber]: {
              bankStatementsDuplicateEntries:
                correspondingChequeEnetriesInBankStatements,
              collectionReportCheckEntry: chequeEntry,
            },
          });
        } else {
          chequeDuplicateEntriesInBankStatements.push({
            [chequeNumber]: {
              bankStatementsDuplicateEntries:
                correspondingChequeEnetriesInBankStatements,
              collectionReportCheckEntry: chequeEntry,
            },
          });
        }
      } else if (correspondingChequeEnetriesInBankStatements.length) {
        matchedChequeInBankStatements.push(chequeEntry);
        correspondingChequeEnetriesInBankStatements[0].alreadyMatched = true;
        chequeEntry.matchingBankStatement = {
          ...correspondingChequeEnetriesInBankStatements[0],
          matchingCREntry: undefined,
        };
        correspondingChequeEnetriesInBankStatements[0].type = "CHECK/DRAFT";
        correspondingChequeEnetriesInBankStatements[0].matchingCREntry = {
          ...chequeEntry,
          matchingBankStatement: undefined,
        };
      }
    });
    const totalOutstandingChequeAmount = findSum(
      outstandingCheques,
      DebitAmountColumnName
    );
    return {
      chequeDuplicateEntriesInBankStatements,
      matchedChequeInBankStatements: sortChequeByCollectionDate(
        matchedChequeInBankStatements
      ),
      outstandingCheques,
      totalOutstandingChequeAmount,
      allChequeEntriesInCollectionRegister,
      bankStatements: bankStatementsCopy,
      collectionReports: collectionReportsCopy,
      rejectedCheques,
    };
  }

  function findSum(data: any[], key: string) {
    return data.reduce((sumAccumulator, chequeEntry) => {
      const chequeAmount = Number(chequeEntry[key]);
      return sumAccumulator + chequeAmount;
    }, 0);
  }

  function findEntriesByPaymentCategory(
    collectionReports: any[],
    category: string
  ) {
    const collectionEntriesStartIndex = collectionReports.findIndex(
      (collectionReport) => {
        const paymentMode: string = collectionReport["Payment Mode:"] || "";
        return paymentMode === category;
      }
    );
    const collectionEntriesEndIndex = collectionReports.findIndex(
      (collectionReport) => {
        const paymentMode: string = collectionReport["Payment Mode:"] || "";
        return paymentMode === `${category} Total`;
      }
    );
    const collectionEntries = collectionReports.slice(
      collectionEntriesStartIndex,
      collectionEntriesEndIndex
    );
    const sortedCheques = sortChequeByCollectionDate(collectionEntries);
    return sortedCheques;
  }

  function getAllChequesAndDrafts(collectionReports: any[]) {
    const allCheques = findEntriesByPaymentCategory(
      collectionReports,
      "Cheque"
    );
    const allDrafts = findEntriesByPaymentCategory(collectionReports, "Draft");
    const draftsAndCheques = [...allCheques, ...allDrafts];
    const reversalEntries = findEntriesByPaymentCategory(
      collectionReports,
      "Reversals"
    );
    const draftsAndChequesEntriesAfterReversalEntryRemoval =
      removeReversalEntriesFromChequesAndDrafts(
        draftsAndCheques,
        reversalEntries
      );
    return draftsAndChequesEntriesAfterReversalEntryRemoval;
  }

  function removeReversalEntriesFromChequesAndDrafts(
    draftsAndCheques: any[],
    reversalEntries: any[]
  ) {
    const removedEntryIds: any[] = [];
    return draftsAndCheques.filter((draftAndChequeEntry) => {
      const chequeDraftId =
        draftAndChequeEntry[ChequeAndCrediCardNumColumnName];
      const debitAmount = Number(draftAndChequeEntry[DebitAmountColumnName]);
      const draftAndChequeEntryInReversals = reversalEntries.find(
        (reversalEntry) => {
          const reversalEntryCheckDraftId =
            reversalEntry[ChequeAndCrediCardNumColumnName];
          const creditAmount = Number(reversalEntry[CreditAmountColumnName]);
          const isReversalMatch =
            reversalEntryCheckDraftId === chequeDraftId &&
            debitAmount === creditAmount;
          const isAlreadyRemoved = removedEntryIds.includes(chequeDraftId);
          if (isReversalMatch && !isAlreadyRemoved) {
            removedEntryIds.push(chequeDraftId);
          }
          return isReversalMatch && !isAlreadyRemoved;
        }
      );
      return !draftAndChequeEntryInReversals;
    });
  }

  function sortChequeByCollectionDate(chequeEntries: any[]) {
    return chequeEntries.sort((chequeEntry, nextCheque) => {
      const collectionDateA = new Date(chequeEntry["Collection Date"]);
      const collectionDateB = new Date(nextCheque["Collection Date"]);
      if (collectionDateA < collectionDateB) return -1;
      if (collectionDateA > collectionDateB) return 1;
      return 0;
    });
  }

  function findByCashTransactionRows(bankStatements: any[]) {
    const bankStatementsCopy = getDataCopy(bankStatements);
    const cashTransactionRows: any[] = [];
    bankStatementsCopy.forEach((actualTransactionRow) => {
      const remarks = actualTransactionRow[BankStatementRemarksColumnName];
      if (remarks === "BY CASH") {
        cashTransactionRows.push({ ...actualTransactionRow });
        actualTransactionRow.alreadyMatched = true;
      }
    });
    const totalByCashAmount = findSum(
      cashTransactionRows,
      BankStatementDepositsColumnName
    );
    return {
      totalByCashAmount,
      byCashTransactions: cashTransactionRows,
      bankStatements: bankStatementsCopy,
    };
  }

  function getOutstandingBankstatement(bankStatements: any[]) {
    return bankStatements.filter((statement) => {
      const alreadyMatched = statement.alreadyMatched;
      const bankDepositRemarks = statement[BankStatementRemarksColumnName];
      const isByCash = bankDepositRemarks.indexOf("BY CASH") > -1;
      return !(alreadyMatched || isByCash);
    });
  }

  function getOutstandingBankstatementsTable(bankStatements: any[]) {
    const outstandingBankStatements =
      getOutstandingBankstatement(bankStatements);
    return getTable(outstandingBankStatements);
  }

  function getOutstandingCollectionReportsTable(collectionReports: any[]) {
    const outstandingCollectionReports = collectionReports.filter(
      (statement) => {
        const alreadyMatched = !!statement.matchingBankStatement;
        return !alreadyMatched;
      }
    );
    return getTable(outstandingCollectionReports);
  }

  function getClearedCollectionReportsTable(collectionReports: any[]) {
    const outstandingCollectionReports = collectionReports.filter(
      (statement) => {
        const alreadyMatched = !!statement.matchingBankStatement;
        return alreadyMatched;
      }
    );
    return getTable(outstandingCollectionReports);
  }

  function getAllMatchedBankStatements(bankStatements: any[]) {
    return bankStatements.filter((bankStatement) => {
      return bankStatement.alreadyMatched;
    });
  }

  let clearedBCA = 0;
  outputData?.bankCreditAdviceFoundInBankStatements.forEach((bca: any) => {
    clearedBCA = clearedBCA + Number(bca["Debit Amount"]) || 0;
  });

  return (
    <div className="App">
      <div style={{ marginBottom: "15px" }}>
        <button onClick={() => history.push("/")}>← Back to Home</button>
      </div>
      <section>
        <Tabs>
          <TabList>
            <Tab>Collection</Tab>
            <Tab>Payments</Tab>
          </TabList>
          <TabPanel>
            <section>
              <div className="fileContainer">
                <label>Upload bank statement</label>
                <input
                  type={"file"}
                  onChange={handleBankStatementFileSelection}
                />
              </div>
              <div className="fileContainer">
                <label>Upload collection report</label>
                <input
                  type={"file"}
                  onChange={handleCollectionReportFileSelection}
                />
              </div>
              <div className="fileContainer">
                <label>Upload previous month bank statements report</label>
                <input
                  type={"file"}
                  onChange={handlePreviousMonthCollectionReportFileSelection}
                />
              </div>
              <div className="fileContainer">
                <label>Upload previous month collection report</label>
                <input
                  type={"file"}
                  onChange={handlePreviousMonthCollectionReportFileSelection}
                />
              </div>
            </section>
            <section>
              <div>
                <button
                  onClick={() => {
                    if (
                      bankStatementsMasterData &&
                      collectionReportsMasterData
                    ) {
                      matchChequeAndBCA(
                        getDataCopy(bankStatementsMasterData),
                        getDataCopy(collectionReportsMasterData)
                      );
                    }
                  }}
                >
                  Match Cheque and BCA
                </button>
              </div>
              {outputData && (
                <section>
                  <div style={{ margin: "10px" }}>
                    <label>Total By Cash: &nbsp;</label>
                    <span>
                      <b>{formatCurrency(outputData?.totalByCashAmount)}</b>
                    </span>
                  </div>
                  <div style={{ margin: "10px" }}>
                    <label>Total Outstanding Cheque: &nbsp;</label>
                    <span>
                      <b>
                        {formatCurrency(
                          outputData?.totalOutstandingChequeAmount
                        )}
                      </b>
                    </span>
                  </div>
                  <div style={{ margin: "10px" }}>
                    <label>Total ouststanding bank credit advice: &nbsp;</label>
                    <span>
                      <b>{formatCurrency(outputData?.outstandingBCAAmount)}</b>
                    </span>
                  </div>
                </section>
              )}
              {outputData && (
                <section>
                  <div>
                    <button
                      onClick={() => {
                        downloadOutputData(outputData);
                      }}
                    >
                      Download data
                    </button>
                  </div>
                  <Tabs>
                    <TabList>
                      <Tab>By CASH</Tab>
                      <Tab>Cheque/Draft</Tab>
                      <Tab>Cheque/Draft Previous Month</Tab>
                      <Tab>Bank credit advice</Tab>
                      <Tab>Bank statements</Tab>
                      <Tab>Collection reports</Tab>
                    </TabList>

                    <TabPanel>
                      {outputData?.byCashTransactions && (
                        <section className="table-container">
                          <h2 style={{ marginBottom: "25px" }}>BY CASH</h2>
                          <div
                            ref={matchingBankStatementsTableContainerRef}
                            dangerouslySetInnerHTML={getTable(
                              outputData?.byCashTransactions
                            )}
                          ></div>
                        </section>
                      )}
                    </TabPanel>

                    <TabPanel>
                      <section>
                        <Tabs>
                          <TabList>
                            <Tab>Outstanding Cheque/Draft</Tab>
                            <Tab>Rejected Cheque/Draft</Tab>
                            <Tab>Cleared Cheque/Draft</Tab>
                            <Tab>All Cheque/Draft</Tab>
                          </TabList>
                          <TabPanel>
                            <section className="table-container">
                              <h2 style={{ marginBottom: "25px" }}>
                                Outstanding Cheques/Drafts
                              </h2>
                              <div
                                ref={outsatndingChequeTableContainerRef}
                                dangerouslySetInnerHTML={getTable(
                                  outputData.outstandingCheques
                                )}
                              ></div>
                            </section>
                          </TabPanel>
                          <TabPanel>
                            <section className="table-container">
                              <h2 style={{ marginBottom: "25px" }}>
                                Rejected Cheques/Drafts
                              </h2>
                              <div
                                dangerouslySetInnerHTML={getTable(
                                  outputData.rejectedCheques
                                )}
                              ></div>
                            </section>
                          </TabPanel>
                          <TabPanel>
                            <section className="table-container">
                              <h2 style={{ marginBottom: "25px" }}>
                                Cleared Cheques/Drafts
                              </h2>
                              <div
                                dangerouslySetInnerHTML={getTable(
                                  outputData.matchedChequeInBankStatements
                                )}
                              ></div>
                            </section>
                          </TabPanel>
                          <TabPanel>
                            <section className="table-container">
                              <h2 style={{ marginBottom: "25px" }}>
                                All Cheque/Draft
                              </h2>
                              <div
                                dangerouslySetInnerHTML={getTable(
                                  outputData.allChequeEntriesInCollectionRegister
                                )}
                              ></div>
                            </section>
                          </TabPanel>
                        </Tabs>
                      </section>
                    </TabPanel>

                    <TabPanel>
                      <section>
                        <Tabs>
                          <TabList>
                            <Tab>Cleared Cheque/Draft Previous Month</Tab>
                          </TabList>
                          <TabPanel>
                            <section className="table-container">
                              <h2 style={{ marginBottom: "25px" }}>
                                Cleared Cheques/Drafts Previous Month
                              </h2>
                              <div
                                dangerouslySetInnerHTML={getTable(
                                  outputData.previousMonthClearedCheques
                                )}
                              ></div>
                            </section>
                          </TabPanel>
                        </Tabs>
                      </section>
                    </TabPanel>

                    <TabPanel>
                      <Tabs>
                        <TabList>
                          <Tab>Outstanding Bank Credit Advice</Tab>
                          <Tab>Cleared Bank Credit Advice</Tab>
                          <Tab>All Bank Credit Advice</Tab>
                        </TabList>
                        <TabPanel>
                          <section className="table-container">
                            <h2 style={{ marginBottom: "25px" }}>
                              Outstanding Bank Credit Advice
                            </h2>
                            <div
                              ref={outsatndingBankCreditAdviceTableContainerRef}
                              dangerouslySetInnerHTML={getTable(
                                outputData?.outstandingBCA
                              )}
                            ></div>
                          </section>
                        </TabPanel>
                        <TabPanel>
                          <section className="table-container">
                            <h2 style={{ marginBottom: "25px" }}>
                              Matching Bank Credit Advice
                            </h2>
                            <section>
                              <div>
                                <h3>
                                  Cleared BCA:{" "}
                                  <b>{formatCurrency(clearedBCA)}</b>
                                </h3>
                              </div>
                            </section>
                            <div
                              ref={matchingCreditAdviceTableContainerRef}
                              dangerouslySetInnerHTML={getTable(
                                outputData?.bankCreditAdviceFoundInBankStatements
                              )}
                            ></div>
                          </section>
                        </TabPanel>
                        <TabPanel>
                          <section className="table-container">
                            <h2 style={{ marginBottom: "25px" }}>
                              All Bank Credit Advice
                            </h2>
                            <div
                              ref={matchingCreditAdviceTableContainerRef}
                              dangerouslySetInnerHTML={getTable(
                                outputData?.allBankCreditAdviceCollectionReportEntriesExludingSwipeEntries
                              )}
                            ></div>
                          </section>
                        </TabPanel>
                      </Tabs>
                    </TabPanel>

                    <TabPanel>
                      <Tabs>
                        <TabList>
                          <Tab>Outstanding Bank Statements</Tab>
                          <Tab>Cleared Bank Statements</Tab>
                          <Tab>All Bank statements</Tab>
                        </TabList>
                        <TabPanel>
                          <section className="table-container">
                            <h2 style={{ marginBottom: "25px" }}>
                              Outstanding Bank Statements
                            </h2>
                            <button
                              onClick={() => {
                                const filename =
                                  "Outstanding_Bank_Statements.xlsx";
                                const outstandingBankstatements =
                                  getOutstandingBankstatement(
                                    outputData?.bankStatements
                                  );
                                const excelData = outstandingBankstatements.map(
                                  (obj: any) => Object.values(obj)
                                );
                                const data = [
                                  Object.keys(outstandingBankstatements[0]),
                                  ...excelData,
                                ];
                                const ws_name = "Outstanding bank statements";
                                downloadExcel({
                                  fileName: filename,
                                  workSheets: [
                                    {
                                      worksheetName: ws_name,
                                      workSheetData: data,
                                    },
                                  ],
                                });
                              }}
                            >
                              Print
                            </button>
                            <div
                              ref={outstandingBankStatementsTableContainerRef}
                              dangerouslySetInnerHTML={getOutstandingBankstatementsTable(
                                outputData?.bankStatements
                              )}
                            ></div>
                          </section>
                        </TabPanel>
                        <TabPanel>
                          <section className="table-container">
                            <h2 style={{ marginBottom: "25px" }}>
                              Cleared Bank Statements
                            </h2>
                            <div
                              ref={matchingBankStatementsTableContainerRef}
                              dangerouslySetInnerHTML={getTable(
                                outputData?.allMatchedBankStatements
                              )}
                            ></div>
                          </section>
                        </TabPanel>
                        <TabPanel>
                          <section className="table-container">
                            <h2 style={{ marginBottom: "25px" }}>
                              All Bank Statements
                            </h2>
                            <div
                              ref={matchingBankStatementsTableContainerRef}
                              dangerouslySetInnerHTML={getTable(
                                outputData?.bankStatements
                              )}
                            ></div>
                          </section>
                        </TabPanel>
                      </Tabs>
                    </TabPanel>

                    <TabPanel>
                      <Tabs>
                        <TabList>
                          <Tab>Outstanding Collection Reports</Tab>
                          <Tab>Cleared Collection Reports</Tab>
                          <Tab>All Collection Reports</Tab>
                        </TabList>
                        <TabPanel>
                          <section className="table-container">
                            <h2 style={{ marginBottom: "25px" }}>
                              Outstanding Collection Reports
                            </h2>
                            <div
                              dangerouslySetInnerHTML={getOutstandingCollectionReportsTable(
                                outputData?.collectionReports
                              )}
                            ></div>
                          </section>
                        </TabPanel>
                        <TabPanel>
                          <section className="table-container">
                            <h2 style={{ marginBottom: "25px" }}>
                              Cleared Collection Reports
                            </h2>
                            <div
                              dangerouslySetInnerHTML={getClearedCollectionReportsTable(
                                outputData?.collectionReports
                              )}
                            ></div>
                          </section>
                        </TabPanel>
                        <TabPanel>
                          <section className="table-container">
                            <h2 style={{ marginBottom: "25px" }}>
                              All Collection Reports
                            </h2>
                            <div
                              dangerouslySetInnerHTML={getTable(
                                outputData?.collectionReports
                              )}
                            ></div>
                          </section>
                        </TabPanel>
                      </Tabs>
                    </TabPanel>
                  </Tabs>
                </section>
              )}
            </section>
          </TabPanel>
          <TabPanel>
            <Payments
              onDisbursementBankStatementFileChange={(
                paymentsBankStatements: BankPaymentStatementItem[]
              ) => {
                setPaymentsBankStatementData(paymentsBankStatements);
              }}
              onDisbursementPaymentRegisterFileChange={(
                paymentRegisterData: PaymentRegisterItem[]
              ) => {
                setPaymentRegisterData(paymentRegisterData);
              }}
            />
          </TabPanel>
        </Tabs>
      </section>
    </div>
  );
}

export default NIAPage;
